function resolveSingleValue(singleValue: string) {
	if (singleValue.indexOf(' - ') <= 0) {
		return singleValue;
	}

	const temporaryArray = singleValue.split(' - ');
	const truncatedItemNumber = temporaryArray[1].replace(/^0+/, '');
	return temporaryArray[0].concat('/', truncatedItemNumber);
}

function resolveConcatenatedData(cellValue: string[]) {
	if (cellValue.length === 0) {
		return [];
	}
	if (cellValue[0].indexOf(' - ') <= 0) {
		return cellValue;
	}

	return cellValue.map(singleValue => resolveSingleValue(singleValue));
}

export function resolveSingleConcatenatedData(cellValue: string) {
	if (cellValue.length === 0) {
		return '';
	}
	return resolveSingleValue(cellValue);
}

export function resolveStringCellValue(cellValue: string | number | null | undefined) {
	if (cellValue === undefined || cellValue === null) {
		return [];
	}

	const normalizedCellValue = String(cellValue);
	if (!normalizedCellValue) {
		return [];
	}

	return resolveConcatenatedData(normalizedCellValue.split(';'));
}
